import '../../_virtual/lodash.js';
import '../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import '@ssml-editor/core';
import { SerializationUtils } from '../../util/serialization-utils.js';

const withSerialization = (editor, serializers, normalizers) => {
  const newEditor = editor;
  newEditor.serialize = () => {
    const elements = SerializationUtils.getDirectChildElements(newEditor);
    const result = SerializationUtils.serializeNodes(elements, serializers);
    return result;
  };
  newEditor.serializeAndNormalize = () => {
    return normalizers.reduce(
      (codes, normalizer) => normalizer(codes),
      newEditor.serialize()
    );
  };
  return newEditor;
};

export { withSerialization };
//# sourceMappingURL=with-serialize.js.map
